import { ImagePlus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/ui/button'

interface LocationBannerCellProps {
  banner: string | null | undefined
  /** Opens the full-size preview of the banner. */
  onPreview: (url: string) => void
}

/** Clickable thumbnail of the banner, or a dash when the location has none (default null). */
export function LocationBannerCell({ banner, onPreview }: LocationBannerCellProps) {
  const { t } = useTranslation()
  if (!banner) {
    return <span className="text-zinc-400">—</span>
  }
  return (
    <button
      type="button"
      aria-label={t('location.previewBanner')}
      title={t('location.previewBanner')}
      className="block cursor-zoom-in rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
      onClick={() => onPreview(banner)}
    >
      <img
        src={banner}
        alt=""
        className="h-10 w-16 rounded-md border border-zinc-200 object-cover transition hover:opacity-80"
        loading="lazy"
      />
    </button>
  )
}

interface LocationBannerEditButtonProps {
  onClick: () => void
}

export function LocationBannerEditButton({ onClick }: LocationBannerEditButtonProps) {
  const { t } = useTranslation()
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      aria-label={t('location.editBanner')}
      title={t('location.editBanner')}
      onClick={onClick}
    >
      <ImagePlus className="h-4 w-4" />
    </Button>
  )
}
